import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  checkboxGroup: {
    gap: "16px",
    justifyContent: "flex-start",
  },
  checkboxContainer: {
    display: "flex",
    gap: "50px",
  },
  formLabel: {
    color: "#308CDB",
    lineHeight: "1.5rem",
    weight: "bold",
    marginBottom: "0.625rem !important",
  },
}));

export default styles;
